import { FeatheredImage } from "../../FeatheredImage";

const A = "/brand";
const IMG = `${A}/blueprint4joy-believinghappy-joyspot-worksheets.jpg`;
const ALT = "A desk flatlay with a laptop open to the JOYspot quiz, orange 'Who Are You?' and 'What Will You Do?' worksheets, a bucket-list handout, a mug reading 'Begin again,' and fresh flowers.";

const INCLUSIONS = [
  "Weekly coaching conversations",
  "Questions that help you notice what you\u2019ve stopped noticing",
  "Space to change your mind",
  "Thoughtful exercises and handouts",
  "Small experiments between sessions",
  "A little homework, because apparently I am that person",
];

export function InsideBelievingHappy() {
  return (
    <section
      data-testid="believing-happy-inside-section"
      className="relative bg-[#FAFAF8]"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-20 md:py-28">

        {/* Row 1 — Big idea + visual. Image is the dominant element. */}
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_3fr] gap-x-16 gap-y-10 items-start">
          <div className="order-2 lg:order-1 reveal">
            <p className="text-xs tracking-[0.24em] uppercase text-[#159E9A] mb-5">
              Inside Believing Happy
            </p>
            <h2
              data-testid="believing-happy-inside-headline"
              className="font-display text-[42px] sm:text-[56px] lg:text-[62px] leading-[1.05] tracking-tight text-[#1C1917]"
            >
              Ten weeks. A little structure. A lot of honest noticing.
            </h2>
            <div className="mt-6 space-y-2 text-lg md:text-xl leading-relaxed text-[#57534E]">
              <p>
                This isn&rsquo;t ten weeks of sitting around talking about
                the life you might want someday.
              </p>
              <p>We&rsquo;ll actually work with it.</p>
            </div>
          </div>

          <div className="order-1 lg:order-2 reveal">
            <div className="relative w-full aspect-[1264/843]">
              <FeatheredImage
                src={IMG}
                alt={ALT}
                testId="believing-happy-inside-image"
                objectPosition="center"
                featherLeft={4}
                featherRight={4}
                featherTop={4}
                featherBottom={4}
                className="absolute inset-0"
              />
            </div>
          </div>
        </div>

        {/* Row 2 — What's included: one compact editorial list, three columns of two */}
        <div className="mt-[52px] md:mt-[66px] max-w-3xl mx-auto reveal">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-x-10 gap-y-5">
            {INCLUSIONS.map((item) => (
              <div key={item} className="flex items-start gap-3 text-left">
                <span className="mt-[11px] w-2 h-2 rounded-full bg-[#159E9A] shrink-0" />
                <p className="text-lg md:text-xl leading-relaxed text-[#57534E]">
                  {item}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Row 3 — Emotional landing, centered */}
        <div className="mt-16 md:mt-24 text-center max-w-2xl mx-auto reveal">
          <p
            data-testid="believing-happy-inside-closing-line"
            className="font-display italic text-2xl md:text-3xl lg:text-4xl leading-snug text-[#1C1917]"
          >
            You&rsquo;re not trying to become someone new.
          </p>
          <p className="mt-2 font-display italic text-2xl md:text-3xl lg:text-4xl leading-snug text-[#159E9A]">
            You&rsquo;re getting better at hearing yourself.
          </p>
        </div>

      </div>
    </section>
  );
}
